import dayjs from 'dayjs';

import { GrowthFilters } from '../types/growth-filters.type';

// Growth sits around 0.10 to 0.35 g/day, so fewer decimals would hide real differences.
export const GROWTH_DECIMALS = 3;
// Mock series where company and market differ, for testing the chart. Real data needs this false.
export const USE_GROWTH_MOCK_DATA = false;

export const DEFAULT_GROWTH_FILTERS: GrowthFilters = {
  grouping: 'month',
  variant: 'fullCycle',
  dateRange: { from: dayjs().subtract(1, 'year').format('YYYY-MM-DD'), to: dayjs().format('YYYY-MM-DD') },
};
